import React, { useEffect, useMemo, useState } from 'react'
import Coins from '@assets/coins.svg'
import { useMetaplexMetadata } from '@hooks/useMetaplexMetadata'
import useAuctionManager from '@hooks/useAuctionManager'
import Image from 'next/image'
import InfoIcon from '@assets/info.svg'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/Tooltip'
import { isPast } from 'date-fns'
const StakingPool = ({ currentBid }: { currentBid: number | undefined }) => {
  const { currentListing } = useAuctionManager()
  const stakingPoolPoolAmount = useMemo(() => {
    return (currentBid * 0.3).toLocaleString()
  }, [currentBid])

  const [auctionEnded, setAuctionEnded] = useState(undefined)

  const { image } = useMetaplexMetadata(currentListing?.tokenMint)

  useEffect(() => {
    if (!currentListing) return

    const auctionEndDate = new Date(currentListing?.endAt.toNumber() * 1000)
    // check if highest bidder date was at least 1 min ago and auction has ended
    setAuctionEnded(isPast(auctionEndDate))
  }, [currentListing])

  if (auctionEnded === undefined) return null

  return (
    <div
      className={`flex border-dark-6 ${auctionEnded ? 'border-t-0' : auctionEnded === false ? 'border-t-[1px]' : ''}`}
    >
      <div className="flex p-4 gap-2 text-sm font-semibold w-full">
        <Coins color={'white'} />
        <span>Staking Pool</span>
        <span>{stakingPoolPoolAmount}</span>
        <Image
          src={image}
          alt="auction-token"
          width={20}
          height={20}
          data-loaded="false"
          onLoad={(event) => {
            event.currentTarget.setAttribute('data-loaded', 'true')
            event.currentTarget.style.opacity = '1'
          }}
          className={`data-[loaded=false]:animate-pulse data-[loaded=false]:bg-dark-7 rounded-full opacity-0 cursor-pointer`}
        />
        <div className="flex flex-1 items-end justify-end">
          <div className="flex items-center justify-center rounded-full hover:bg-dark-5 cursor-pointer p-[0.5px]">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <InfoIcon color="var(--dewi_colors_dark_3)" />
                </TooltipTrigger>
                <TooltipContent className="max-w-[300px] mr-12 p-4">
                  <p className="text-xs text-white font-semibold">
                    The staking pool is the amount of tokens that will be
                    distributed equally to the cats that have been staked prior
                    to the auction. Legendary cats have a weight multiplier of
                    2.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StakingPool
